/* eslint-disable react/prop-types */
import React from 'react';
import { components } from 'react-select';

const MultiValue = (message) => (props) => {
  const {
    selectProps: { value: values }
  } = props;

  const value =
    values && Array.isArray(values) && values.length > 0 && (values.length === 1 ? values[0].label : message);

  return <components.SingleValue {...props}>{value}</components.SingleValue>;
};

export default MultiValue;
